import { fetchExpertisesBeat } from './asyncThunk';
import { getListSlice, initialListState } from '../getListSlice';
import { IListState } from '../types';
import { IExpertise } from '../../../api/base/Expertises/types';

export type IExpertisesState = IListState<IExpertise>;

const initialState: IExpertisesState = { ...initialListState };

const expertisesSliceBeat = getListSlice({
  moduleName: 'expertises',
  fetchDataThunk: fetchExpertisesBeat,
  initialState,
});

export const expertisesReducerBeat = expertisesSliceBeat.reducer;
